const UsaFlag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor' {...props}>
    <g clipPath='url(#clip0_1061_64436)'>
      <path
        d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
        fill='#F0F0F0'
      />
      <path
        d='M7.65234 8.00005H16.0002C16.0002 7.27799 15.9039 6.57849 15.7246 5.91309H7.65234V8.00005Z'
        fill='#D80027'
      />
      <path d='M7.65234 3.82623H14.826C14.3362 3.0271 13.7101 2.32076 12.98 1.73926H7.65234V3.82623Z' fill='#D80027' />
      <path
        d='M7.99941 16.0004C9.88219 16.0004 11.6127 15.3496 12.9793 14.2612H3.01953C4.38609 15.3496 6.11663 16.0004 7.99941 16.0004Z'
        fill='#D80027'
      />
      <path
        d='M1.17398 12.1739H14.8256C15.2188 11.5324 15.5237 10.8311 15.7242 10.0869H0.275391C0.475922 10.8311 0.780828 11.5324 1.17398 12.1739Z'
        fill='#D80027'
      />
      <path
        d='M3.70575 1.24931H4.43478L3.75666 1.74197L4.01569 2.53912L3.33759 2.04647L2.6595 2.53912L2.88325 1.85047C2.28619 2.34781 1.76287 2.9305 1.33162 3.57975H1.56522L1.13356 3.89334C1.06631 4.00553 1.00181 4.1195 0.94 4.23516L1.14612 4.86956L0.761563 4.59016C0.665969 4.79269 0.578531 4.99978 0.499938 5.21119L0.727031 5.91019H1.56522L0.887094 6.40284L1.14612 7.2L0.468031 6.70734L0.0618437 7.00247C0.0211875 7.32928 0 7.66216 0 8H8C8 3.58175 8 3.06087 8 0C6.41963 0 4.94641 0.458438 3.70575 1.24931ZM4.01569 7.2L3.33759 6.70734L2.6595 7.2L2.91853 6.40284L2.24041 5.91019H3.07859L3.33759 5.11303L3.59659 5.91019H4.43478L3.75666 6.40284L4.01569 7.2ZM3.75666 4.07241L4.01569 4.86956L3.33759 4.37691L2.6595 4.86956L2.91853 4.07241L2.24041 3.57975H3.07859L3.33759 2.78259L3.59659 3.57975H4.43478L3.75666 4.07241ZM6.88525 7.2L6.20716 6.70734L5.52906 7.2L5.78809 6.40284L5.10997 5.91019H5.94816L6.20716 5.11303L6.46616 5.91019H7.30434L6.62622 6.40284L6.88525 7.2ZM6.62622 4.07241L6.88525 4.86956L6.20716 4.37691L5.52906 4.86956L5.78809 4.07241L5.10997 3.57975H5.94816L6.20716 2.78259L6.46616 3.57975H7.30434L6.62622 4.07241ZM6.62622 1.74197L6.88525 2.53912L6.20716 2.04647L5.52906 2.53912L5.78809 1.74197L5.10997 1.24931H5.94816L6.20716 0.452156L6.46616 1.24931H7.30434L6.62622 1.74197Z'
        fill='#0052B4'
      />
    </g>
    <defs>
      <clipPath id='clip0_1061_64436'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default UsaFlag;
